import React, { useState, useEffect } from 'react'
import './ImageContainer.css'

import { connect } from 'react-redux'
import {
  getImagesVisible,
  getPrevNextEstancias,
  getTextoInformacion,
  getTextoCerrarInformacion,
  setImageLoaded,
  setImagesLoading
} from '../../modules/reducer'

import { useSpring, animated } from 'react-spring'
import { useGesture } from 'react-with-gesture'

import IconArrow from './IconArrow'
import IconInformation from './IconInformation'

import ImageEstancia from './ImageEstancia'
import MeasureWidth from './MeasureWidth'

import { default as MenuIdiomasV } from '../Header/MenuV'
import MenuProyectosV from '../Header/MenuProyectosV'

import IconLoadingNumber from './IconLoadingNumber'

import {gaEvent} from '../../Cookies'

let getValues = null
const f = p => () => p

const ImageContainer = ({
  sizeContainer,
  images,
  estanciaPrev,
  estanciaNext,
  history,
  textoInformacion,
  cerrarInformacion,
  setImageLoaded,
  loaded,
  imagesLoading,
  setImagesLoading
}) => {
  getValues = f({ estanciaPrev, estanciaNext })

  const [open, setOpen] = useState(false)

  const { opacity, display } = useSpring({
    opacity: open ? 1 : 0,
    display: open ? 'block' : 'none'
  })

  const [bind, { delta, down }] = useGesture({
    onUp: e => {
      const values = getValues()
      if (Math.abs(e.delta[0]) < 125) return
      if (e.delta[0] > 0) {
        if (values.estanciaPrev !== null) {
          history.push(values.estanciaPrev.path)
        }
      } else if (e.delta[0] < 0) {
        if (values.estanciaNext !== null) {
          history.push(values.estanciaNext.path)
        }
      }
    }
  })
  const { x } = useSpring({
    x: down ? delta[0] : 0
  })

  let height = null
  let topIcon = ''
  let imagenPrev = null
  let imagenNext = null
  let menuIdiomas = null
  let menuProyectosV = null

  const mq = window.matchMedia('(max-width: 823px)')

  if (mq.matches) {
    height = 257
    topIcon = `calc(${height / 2}px - 2em)`

    imagenPrev = estanciaPrev ? (
      <ImageEstancia {...estanciaPrev} visible prev={true} next={false} x={x} />
    ) : null

    imagenNext = estanciaNext ? (
      <ImageEstancia {...estanciaNext} visible prev={false} next={true} x={x} />
    ) : null

    menuIdiomas = <MenuIdiomasV history={history} />

    menuProyectosV = (
      <MenuProyectosV
        todo={true}
        style={{
          left: 0,
          top: 0
          /*boxShadow:
            '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'*/
        }}
      />
    )
  } else {
    topIcon = `calc(${sizeContainer.height / 2}px - 2em)`
    menuProyectosV = (
      <MenuProyectosV
        todo={false}
        style={{
          left: '5.2em',
          top: '-20px'
          /*boxShadow:
            '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'*/
        }}
      />
    )
  }

  useEffect(
    () => {
      const checkImage = (image, index, imagesLoaded) =>
        new Promise(resolve => {
          const img = new Image()
          img.onload = () => {
            resolve(image)
          }
          //img.onerror = () => resolve({ path, status: 'error' })

          img.src = image.src
        })

      const imagesLoaded = images.reduce((result, image) => {
        if (!image.loaded) {
          if (image.tipo === 'estancia') {
            result.push({
              tipo: image.tipo,
              id: image.id.substring(1),
              src: image.src
            })
          } else {
            result.push({ tipo: image.tipo, id: image.id, src: image.src })
          }
        }
        return result
      }, [])

      if (imagesLoaded.length > 0) {
        const newImagesLoading = imagesLoaded.reduce((result, image) => {
          if (
            !imagesLoading.some(
              im => im.tipo === image.tipo && im.id === image.id
            )
          ) {
            result.push(image)
          }
          return result
        }, [])

        setImagesLoading(newImagesLoading)

        newImagesLoading.forEach(image => {
          checkImage(image).then(image => {
            setImageLoaded({ tipo: image.tipo, id: image.id })
          })
        })
      }
    },
    [images, setImageLoaded, imagesLoading, setImagesLoading]
  )

  return (
    <div
      {...bind()}
      className="image-container col-9_sm-12_md-8 grid-noGutter"
      style={{
        height
      }}
    >
      <MeasureWidth />
      {menuIdiomas}
      {menuProyectosV}
      <animated.div className="modal" style={{ opacity, display }}>
        {textoInformacion}
        <div className="modal-cerrar" onClick={e => setOpen(false)}>
          {cerrarInformacion}
        </div>
      </animated.div>
      {imagenPrev}
      {loaded ? (
        images.map(image => (
          <ImageEstancia
            key={image.id}
            src={image.src}
            width={image.width}
            height={image.height}
            visible={image.visible}
            prev={false}
            next={false}
            x={x}
          />
        ))
      ) : (
        <IconLoadingNumber />
      )}
      {imagenNext}
      {estanciaPrev !== null ? (
        <div
          className="image-container-icon image-container-prev"
          style={{
            top: topIcon
          }}
          onClick={e => history.push(estanciaPrev.path)}
        >
          <IconArrow size="4em" color="#F07204" />
        </div>
      ) : null}
      {estanciaNext !== null ? (
        <div
          className="image-container-icon image-container-next"
          style={{
            top: topIcon
          }}
          onClick={e => history.push(estanciaNext.path)}
        >
          <IconArrow size="4em" color="#F07204" />
        </div>
      ) : null}
      <div
        className="image-container-information col-bottom"
        onClick={e => {
          gaEvent({
            category: 'Ver información',
            action: 'Ver información'
          })
          setOpen(true)
        }}
      >
        <IconInformation size="1.5em" color="#F07204" />
      </div>
    </div>
  )
}

const mapStateToProps = ({ reducer }, ownProps) => {
  const prevNext = getPrevNextEstancias(reducer)
  const images = getImagesVisible(reducer)
  const loaded = images.reduce((result, image) => {
    return result && image.loaded
  }, true)

  return {
    images,
    loaded,
    imagesLoading: reducer.imagesLoading,
    sizeContainer: reducer.sizeImageContainer,
    estanciaPrev: prevNext.prev,
    estanciaNext: prevNext.next,
    textoInformacion: getTextoInformacion(reducer),
    cerrarInformacion: getTextoCerrarInformacion(reducer)
  }
}

const mapDispatchToProps = {
  setImageLoaded,
  setImagesLoading
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ImageContainer)
